<div class="entity-card fade-in" #cardContainer>
  <ng-template appEntityInformationViewComponent></ng-template>
</div>
